module.exports = __webpack_public_path__ + "Qqx6JfPDtXSiUWszk/rdc_pro_logo.svg";